const navbar = (state = true, action: any) => {
    switch (action.type) {
        case 'SHOW_DROPDOWN_NAVBAR':
            return action.show
        default:
            return state
    }
}

export default navbar